<div
  class="mt-2 flex h-full min-h-0 shrink-0 flex-col overflow-hidden rounded-r-sm border-t border-r border-(--divider-normal) bg-(--background-sidebar) pb-2"
  [class]="{ 'w-66.5': !minimised(), 'w-12': minimised() }"
  data-testid="div-sidebar"
>
  <div class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto" data-testid="div-sidebar-item-container">
    <ng-content></ng-content>
  </div>
  <div class="flex shrink-0 cursor-pointer flex-col border-t border-(--divider-panels)">
    <nsp-sidebar-item
      [icon]="'pi pi-cog'"
      [label]="'SHARED.SIDEBAR.SETTINGS' | translate"
      (itemClick)="toggleSettings()"
      data-testid="sidebar-item-settings"
    ></nsp-sidebar-item>

    <div
      class="grid transition-[grid-template-rows] duration-300 ease-in-out"
      [class]="{ 'grid-rows-[1fr]': settingsOpen(), 'grid-rows-[0fr]': !settingsOpen() }"
      data-testid="div-settings-panel"
    >
      <div class="overflow-hidden">
        <ng-content select="[settingsPanel]"></ng-content>
      </div>
    </div>

    <div class="border-t border-(--divider-panels)">
      @if (minimised()) {
        <nsp-sidebar-item
          [label]="'SHARED.SIDEBAR.MAXIMISE' | translate"
          (itemClick)="toggle()"
          icon="pi pi-angle-right"
          data-testid="sidebar-item-maximise"
        ></nsp-sidebar-item>
      } @else {
        <nsp-sidebar-item
          [label]="'SHARED.SIDEBAR.MINIMISE' | translate"
          (itemClick)="toggle()"
          icon="pi pi-angle-left"
          data-testid="sidebar-item-minimise"
        ></nsp-sidebar-item>
      }
    </div>
  </div>
</div>
